export const SizeClasses = {
  lg: 'text-4xl',
  base: 'text-4xl',
  sm: 'text-3xl',
  xs: 'text-2xl',
}

export const SizeResponsiveClasses = {
  lg: 'lg:text-6xl',
  base: 'lg:text-5xl',
  sm: 'lg:text-4xl',
  xs: 'lg:text-3xl',
}

export const LeadingClasses = {
  none: 'leading-none',
  tight: 'leading-tight',
}
